import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subject, BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { ErrorService } from "../error/err.service";
import { TimeZoneService } from "../services/time-zone.service";
import { AlertsvarService } from "./alertsvar.service";
import { AlertLongPollingAPIManagement } from "./statemanagement/apipolling";
import { LongPollingPromiseAPIManagement } from "../shared/stateapimanagement/promiselongpolling-withstate";
import { LongPollingStateLessAPIManagement } from "../shared/stateapimanagement/longpolling-withoutstate";
import { LongPollingAPIManagement } from "../shared/stateapimanagement/longpolling-withstate";
import { takeUntil } from "rxjs/operators";
import { SharedService } from "../services/shared.service";
import { ToastService } from "../shared/custom-overlay/toast/toast.service";
import { number } from "echarts";

import { RESTPROMISE } from "../shared/stateapimanagement/promisewithoutstate";
import { FormControl, FormGroup } from "@angular/forms";

@Injectable({
    providedIn: 'root'   
  })

export class AlertsService {

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private errorservice: ErrorService,
    private timezoneservice: TimeZoneService,
    private toastService: ToastService
    // public alertvarservice:AlertsvarService
  ) {
    this.sharedService.$userLoggedoff.pipe().subscribe((loggedoff) => {
      this.customerChangeLogggedOff.next(loggedoff);
    })
  }

  alertLandingcomponentDestroyed: Subject<number> = new Subject();

 
  



  alertRules={
    "context":{
        "rule_id":number,
        "description":'',
        "activate_rule":'',
        "run_retroactively":''
    },
    "ruleconditions":{
        "query":''
    },
    "closure_action":{
        "action":{
            "type":'',
            "value":{
                "state":{
                    "type":'',
                    "value":{
                        "reason":''
                    }
                
                },
            "comments":''
        }
    },
        "add_tags":{},
        "no_action_required":false
    }
}




  alertFilter={"filters":{"time":{"values":[
    {
        "disp": "Last 1 Hour",
        "value": [
            -1,
            "hour",
            1
        ],
        "count": null
    },
    {
        "disp": "Last 3 Hour",
        "value": [
            -1,
            "hour",
            3
        ],
        "count": null
    },
    {
        "disp": "Last 24 Hour",
        "value": [
            -1,
            "hour",
            24
        ],
        "count": null
    },
    {
        "disp": "Today",
        "value": [
            0,
            "today",
            0
        ],
        "count": null
    },
    {
        "disp": "Yesterday",
        "value": [
            -1,
            "yesterday",
            1
        ],
        "count": null
    },
    {
        "disp": "last 7 Days",
        "value": [
            -1,
            "day",
            6
        ],
        "count": null
    },
    {
        "disp": "Last 30 Days",
        "value": [
            -1,
            "day",
            29
        ],
        "count": null
    },
    {
        "disp": "Last 90 Days",
        "value": [
            -1,
            "day",
            89
        ],
        "count": null
    },
    {
        "disp": "Last 120 Days",
        "value": [
            -1,
            "day",
            119
        ],
        "count": null
    },
    {
        "disp": "Last 180 Days",
        "value": [
            -1,
            "day",
            179
        ],
        "count": null
    },
    {
        "disp": "Last 300 Days",
        "value": [
            -1,
            "day",
            299
        ],
        "count": null
    }
  ],
  "multi_select":false,
  "mandatory":true},

  "platform":{
    "values":[
    {"disp":"Firewall Fortigate","value":"firewall_fortigate","count": 10298},
    {"disp":"Cisco Switch","value":"cisco_switch","count": 456},
    {"disp":"Firewall PaloAlto","value":"firewall_paloalto","count": 987},
    {"disp":"Windows","value":"windows","count": null},
    {"disp":"Linux","value":"linux","count": null}
  ],
  "multi_select":false,
  "mandatory":true},

  "severity":{"values":[
    {
        "disp": "Info",
        "value": "informational",
        "count": null
    },
    {
        "disp": "Low",
        "value": "low",
        "count": null
    },
    {
        "disp": "Medium",
        "value": "medium",
        "count": null
    },
    {
        "disp": "High",
        "value": "high",
        "count": null
    },
    {
        "disp": "Critical",
        "value": "critical",
        "count": null
    }
  ],"multi_select":true,
  "mandatory":false},
  "title":{"values":[],"multi_select":true,
  "mandatory":false},

  "data_type":{"values":[
    {"disp":"Port","value":"port","count": 10298},
    {"disp":"Src IP","value":"src_ip","count": 108},
    {"disp":"Dst IP","value":"dst_ip","count": 456},
    {"disp":"URL","value":"url","count": 987}
  ],"multi_select":true,
  "mandatory":false},

  "observable":{"values":[
    {"disp":"80","value":"80","count": 10298},
    {"disp":"514","value":"514","count": 108},
    {"disp":"1.2.3.4","value":"1.2.3.4","count": 456},
    {"disp":"192.168.1.1","value":"192.168.1.1","count": 987}
  ],"multi_select":true,
  "mandatory":false},

  "signature":{"values":[],"multi_select":true,
  "mandatory":false},

  "tags":{
    "values":[

        {"killchain": [ {
            "value": "reconnaissance",
            "disp": "Reconnaissance",
            "parent": "killchain"
        },
        {
            "value": "threatgroup1319",
            "disp": "Threat Group 1319",
            "parent": "killchain"
        }]},
        {"compliance": [ {
            "value": "pcidss",
            "disp": "PCI-DSS",
            "parent": "compliance"
        },
        {
            "value": "gprc",
            "disp": "GPRC",
            "parent": "compliance"
        },
        {
            "value": "iso27001",
            "disp": "ISO 27001",
            "parent": "compliance"
        },
        {
            "value": "hippa",
            "disp": "HIPPA",
            "parent": "compliance"
        },
        {
            "value": "low_diskspace",
            "disp": "low_diskspace",
            "parent": "compliance"
        },
        {
            "value": "connection_attempt",
            "disp": "connection_attempt",
            "parent": "compliance"
        },
        {
            "value": "gdpr",
            "disp": "GDPR",
            "parent": "compliance"
        },
        {
            "value": "exploit_attempt",
            "disp": "exploit_attempt",
            "parent": "compliance"
        },
        {
            "value": "invalid_login",
            "disp": "invalid_login",
            "parent": "compliance"
        },
        {
            "value": "config_changed",
            "disp": "config_changed",
            "parent": "compliance"
        },
        {
            "value": "authentication_failures",
            "disp": "authentication_failures",
            "parent": "compliance"
        },
        {
            "value": "promisc",
            "disp": "promisc",
            "parent": "compliance"
        },
        {
            "value": "gpg",
            "disp": "GPG",
            "parent": "compliance"
        },
        {
            "value": "tsc",
            "disp": "TSC",
            "parent": "compliance"
        },
        {
            "value": "recon",
            "disp": "recon",
            "parent": "compliance"
        },
        {
            "value": "nist",
            "disp": "NIST",
            "parent": "compliance"
        },
        {
            "value": "system_shutdown",
            "disp": "system_shutdown",
            "parent": "compliance"
        },
        {
            "value": "authentication_failed",
            "disp": "authentication_failed",
            "parent": "compliance"
        },
        {
            "value": "authentication_success",
            "disp": "authentication_success",
            "parent": "compliance"
        },
        {
            "value": "service_availability",
            "disp": "service_availability",
            "parent": "compliance"
        },
        {
            "value": "access_denied",
            "disp": "access_denied",
            "parent": "compliance"
        }]},
        {"mitreattack": [{
            "value": "command_and_control",
            "disp": "command_and_control",
            "parent": "mitreattack"
        },
        {
            "value": "credential_access",
            "disp": "credential_access",
            "parent": "mitreattack"
        },
        {
            "value": "defense_evasion",
            "disp": "defense_evasion",
            "parent": "mitreattack"
        },
        {
            "value": "execution",
            "disp": "execution",
            "parent": "mitreattack"
        },
        {
            "value": "impact",
            "disp": "impact",
            "parent": "mitreattack"
        },
        {
            "value": "lateral_movement",
            "disp": "lateral_movement",
            "parent": "mitreattack"
        },
        {
            "value": "persistence",
            "disp": "persistence",
            "parent": "mitreattack"
        },
        {
            "value": "privilege_escalation",
            "disp": "privilege_escalation",
            "parent": "mitreattack"
        },
        {
            "value": "resource_development",
            "disp": "resource_development",
            "parent": "mitreattack"
        },
        {
            "value": "t1003",
            "disp": "t1003",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.001",
            "disp": "t1003.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1008",
            "disp": "t1008",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.002",
            "disp": "t1021.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1036.003",
            "disp": "t1036.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1047",
            "disp": "t1047",
            "parent": "mitreattack"
        },
        {
            "value": "t1053",
            "disp": "t1053",
            "parent": "mitreattack"
        },
        {
            "value": "t1053.005",
            "disp": "t1053.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1059.005",
            "disp": "t1059.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1059.007",
            "disp": "t1059.007",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.005",
            "disp": "t1070.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1105",
            "disp": "t1105",
            "parent": "mitreattack"
        },
        {
            "value": "t1112",
            "disp": "t1112",
            "parent": "mitreattack"
        },
        {
            "value": "t1133",
            "disp": "t1133",
            "parent": "mitreattack"
        },
        {
            "value": "t1137",
            "disp": "t1137",
            "parent": "mitreattack"
        },
        {
            "value": "t1137.006",
            "disp": "t1137.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1140",
            "disp": "t1140",
            "parent": "mitreattack"
        },
        {
            "value": "t1202",
            "disp": "t1202",
            "parent": "mitreattack"
        },
        {
            "value": "t1203",
            "disp": "t1203",
            "parent": "mitreattack"
        },
        {
            "value": "t1204.002",
            "disp": "t1204.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1218",
            "disp": "t1218",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.011",
            "disp": "t1218.011",
            "parent": "mitreattack"
        },
        {
            "value": "t1221",
            "disp": "t1221",
            "parent": "mitreattack"
        },
        {
            "value": "t1490",
            "disp": "t1490",
            "parent": "mitreattack"
        },
        {
            "value": "t1543.003",
            "disp": "t1543.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1546",
            "disp": "t1546",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.009",
            "disp": "t1546.009",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.011",
            "disp": "t1546.011",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.012",
            "disp": "t1546.012",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.015",
            "disp": "t1546.015",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.001",
            "disp": "t1547.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.003",
            "disp": "t1547.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.004",
            "disp": "t1547.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.010",
            "disp": "t1547.010",
            "parent": "mitreattack"
        },
        {
            "value": "t1548",
            "disp": "t1548",
            "parent": "mitreattack"
        },
        {
            "value": "t1548.002",
            "disp": "t1548.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1553.003",
            "disp": "t1553.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1559.002",
            "disp": "t1559.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1562",
            "disp": "t1562",
            "parent": "mitreattack"
        },
        {
            "value": "t1562.001",
            "disp": "t1562.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1562.002",
            "disp": "t1562.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1562.004",
            "disp": "t1562.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1564",
            "disp": "t1564",
            "parent": "mitreattack"
        },
        {
            "value": "t1564.001",
            "disp": "t1564.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1564.002",
            "disp": "t1564.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1566",
            "disp": "t1566",
            "parent": "mitreattack"
        },
        {
            "value": "t1569.002",
            "disp": "t1569.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1574",
            "disp": "t1574",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.002",
            "disp": "t1574.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.012",
            "disp": "t1574.012",
            "parent": "mitreattack"
        },
        {
            "value": "t1588.002",
            "disp": "t1588.002",
            "parent": "mitreattack"
        },
        {
            "value": "2013-01-002",
            "disp": "2013-01-002",
            "parent": "mitreattack"
        },
        {
            "value": "2019-04-001",
            "disp": "2019-04-001",
            "parent": "mitreattack"
        },
        {
            "value": "discovery",
            "disp": "discovery",
            "parent": "mitreattack"
        },
        {
            "value": "t1059-001",
            "disp": "t1059-001",
            "parent": "mitreattack"
        },
        {
            "value": "t1027",
            "disp": "t1027",
            "parent": "mitreattack"
        },
        {
            "value": "t1059.001",
            "disp": "t1059.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1049",
            "disp": "t1049",
            "parent": "mitreattack"
        },
        {
            "value": "initial_access",
            "disp": "initial_access",
            "parent": "mitreattack"
        },
        {
            "value": "t1078",
            "disp": "t1078",
            "parent": "mitreattack"
        },
        {
            "value": "t1069.001",
            "disp": "t1069.001",
            "parent": "mitreattack"
        },
        {
            "value": "collection",
            "disp": "collection",
            "parent": "mitreattack"
        },
        {
            "value": "t1074.001",
            "disp": "t1074.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1136.001",
            "disp": "t1136.001",
            "parent": "mitreattack"
        },
        {
            "value": "g0049",
            "disp": "g0049",
            "parent": "mitreattack"
        },
        {
            "value": "s0111",
            "disp": "s0111",
            "parent": "mitreattack"
        },
        {
            "value": "t1071.004",
            "disp": "t1071.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.003",
            "disp": "t1218.003",
            "parent": "mitreattack"
        },
        {
            "value": "s0005",
            "disp": "s0005",
            "parent": "mitreattack"
        },
        {
            "value": "t1137.002",
            "disp": "t1137.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1090",
            "disp": "t1090",
            "parent": "mitreattack"
        },
        {
            "value": "t1547",
            "disp": "t1547",
            "parent": "mitreattack"
        },
        {
            "value": "2014-11-003 ",
            "disp": "2014-11-003 ",
            "parent": "mitreattack"
        },
        {
            "value": "2014-11-008",
            "disp": "2014-11-008",
            "parent": "mitreattack"
        },
        {
            "value": "exfiltration",
            "disp": "exfiltration",
            "parent": "mitreattack"
        },
        {
            "value": "g0001",
            "disp": "g0001",
            "parent": "mitreattack"
        },
        {
            "value": "g0004",
            "disp": "g0004",
            "parent": "mitreattack"
        },
        {
            "value": "g0007",
            "disp": "g0007",
            "parent": "mitreattack"
        },
        {
            "value": "g0009",
            "disp": "g0009",
            "parent": "mitreattack"
        },
        {
            "value": "g0010",
            "disp": "g0010",
            "parent": "mitreattack"
        },
        {
            "value": "g0016",
            "disp": "g0016",
            "parent": "mitreattack"
        },
        {
            "value": "g0020",
            "disp": "g0020",
            "parent": "mitreattack"
        },
        {
            "value": "g0022",
            "disp": "g0022",
            "parent": "mitreattack"
        },
        {
            "value": "g0027",
            "disp": "g0027",
            "parent": "mitreattack"
        },
        {
            "value": "g0030",
            "disp": "g0030",
            "parent": "mitreattack"
        },
        {
            "value": "g0032",
            "disp": "g0032",
            "parent": "mitreattack"
        },
        {
            "value": "g0035",
            "disp": "g0035",
            "parent": "mitreattack"
        },
        {
            "value": "g0044",
            "disp": "g0044",
            "parent": "mitreattack"
        },
        {
            "value": "g0045",
            "disp": "g0045",
            "parent": "mitreattack"
        },
        {
            "value": "g0046",
            "disp": "g0046",
            "parent": "mitreattack"
        },
        {
            "value": "g0047",
            "disp": "g0047",
            "parent": "mitreattack"
        },
        {
            "value": "g0050",
            "disp": "g0050",
            "parent": "mitreattack"
        },
        {
            "value": "g0060",
            "disp": "g0060",
            "parent": "mitreattack"
        },
        {
            "value": "g0064",
            "disp": "g0064",
            "parent": "mitreattack"
        },
        {
            "value": "g0069",
            "disp": "g0069",
            "parent": "mitreattack"
        },
        {
            "value": "g0075",
            "disp": "g0075",
            "parent": "mitreattack"
        },
        {
            "value": "g0091",
            "disp": "g0091",
            "parent": "mitreattack"
        },
        {
            "value": "g0092",
            "disp": "g0092",
            "parent": "mitreattack"
        },
        {
            "value": "g0093",
            "disp": "g0093",
            "parent": "mitreattack"
        },
        {
            "value": "g0096",
            "disp": "g0096",
            "parent": "mitreattack"
        },
        {
            "value": "g0115",
            "disp": "g0115",
            "parent": "mitreattack"
        },
        {
            "value": "g0128",
            "disp": "g0128",
            "parent": "mitreattack"
        },
        {
            "value": "reconnaissance",
            "disp": "reconnaissance",
            "parent": "mitreattack"
        },
        {
            "value": "s0002",
            "disp": "s0002",
            "parent": "mitreattack"
        },
        {
            "value": "s0013",
            "disp": "s0013",
            "parent": "mitreattack"
        },
        {
            "value": "s0029",
            "disp": "s0029",
            "parent": "mitreattack"
        },
        {
            "value": "s0039",
            "disp": "s0039",
            "parent": "mitreattack"
        },
        {
            "value": "s0040",
            "disp": "s0040",
            "parent": "mitreattack"
        },
        {
            "value": "s0075",
            "disp": "s0075",
            "parent": "mitreattack"
        },
        {
            "value": "s0081",
            "disp": "s0081",
            "parent": "mitreattack"
        },
        {
            "value": "s0106",
            "disp": "s0106",
            "parent": "mitreattack"
        },
        {
            "value": "s0108",
            "disp": "s0108",
            "parent": "mitreattack"
        },
        {
            "value": "s0160",
            "disp": "s0160",
            "parent": "mitreattack"
        },
        {
            "value": "s0190",
            "disp": "s0190",
            "parent": "mitreattack"
        },
        {
            "value": "s0195",
            "disp": "s0195",
            "parent": "mitreattack"
        },
        {
            "value": "s0246",
            "disp": "s0246",
            "parent": "mitreattack"
        },
        {
            "value": "s0363",
            "disp": "s0363",
            "parent": "mitreattack"
        },
        {
            "value": "s0404",
            "disp": "s0404",
            "parent": "mitreattack"
        },
        {
            "value": "s0412",
            "disp": "s0412",
            "parent": "mitreattack"
        },
        {
            "value": "s0575",
            "disp": "s0575",
            "parent": "mitreattack"
        },
        {
            "value": "t1001.003",
            "disp": "t1001.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.002",
            "disp": "t1003.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.003",
            "disp": "t1003.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.004",
            "disp": "t1003.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.005",
            "disp": "t1003.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1003.006",
            "disp": "t1003.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1005",
            "disp": "t1005",
            "parent": "mitreattack"
        },
        {
            "value": "t1007",
            "disp": "t1007",
            "parent": "mitreattack"
        },
        {
            "value": "t1010",
            "disp": "t1010",
            "parent": "mitreattack"
        },
        {
            "value": "t1012",
            "disp": "t1012",
            "parent": "mitreattack"
        },
        {
            "value": "t1016",
            "disp": "t1016",
            "parent": "mitreattack"
        },
        {
            "value": "t1018",
            "disp": "t1018",
            "parent": "mitreattack"
        },
        {
            "value": "t1020",
            "disp": "t1020",
            "parent": "mitreattack"
        },
        {
            "value": "t1021",
            "disp": "t1021",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.001",
            "disp": "t1021.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.003",
            "disp": "t1021.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.004",
            "disp": "t1021.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.005",
            "disp": "t1021.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1021.006",
            "disp": "t1021.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1027.001",
            "disp": "t1027.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1027.003",
            "disp": "t1027.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1027.004",
            "disp": "t1027.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1027.005",
            "disp": "t1027.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1027.009",
            "disp": "t1027.009",
            "parent": "mitreattack"
        },
        {
            "value": "t1033",
            "disp": "t1033",
            "parent": "mitreattack"
        },
        {
            "value": "t1035",
            "disp": "t1035",
            "parent": "mitreattack"
        },
        {
            "value": "t1036",
            "disp": "t1036",
            "parent": "mitreattack"
        },
        {
            "value": "t1036.002",
            "disp": "t1036.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1036.004",
            "disp": "t1036.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1036.005",
            "disp": "t1036.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1036.007",
            "disp": "t1036.007",
            "parent": "mitreattack"
        },
        {
            "value": "t1037.001",
            "disp": "t1037.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1039",
            "disp": "t1039",
            "parent": "mitreattack"
        },
        {
            "value": "t1040",
            "disp": "t1040",
            "parent": "mitreattack"
        },
        {
            "value": "t1041",
            "disp": "t1041",
            "parent": "mitreattack"
        },
        {
            "value": "t1046",
            "disp": "t1046",
            "parent": "mitreattack"
        },
        {
            "value": "t1048",
            "disp": "t1048",
            "parent": "mitreattack"
        },
        {
            "value": "t1048.001",
            "disp": "t1048.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1048.003",
            "disp": "t1048.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1050",
            "disp": "t1050",
            "parent": "mitreattack"
        },
        {
            "value": "t1053.002",
            "disp": "t1053.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1055",
            "disp": "t1055",
            "parent": "mitreattack"
        },
        {
            "value": "t1055.001",
            "disp": "t1055.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1056.001",
            "disp": "t1056.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1057",
            "disp": "t1057",
            "parent": "mitreattack"
        },
        {
            "value": "t1059",
            "disp": "t1059",
            "parent": "mitreattack"
        },
        {
            "value": "t1059.003",
            "disp": "t1059.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1059.006",
            "disp": "t1059.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1068",
            "disp": "t1068",
            "parent": "mitreattack"
        },
        {
            "value": "t1069",
            "disp": "t1069",
            "parent": "mitreattack"
        },
        {
            "value": "t1069.002",
            "disp": "t1069.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1070",
            "disp": "t1070",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.001",
            "disp": "t1070.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.003",
            "disp": "t1070.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.004",
            "disp": "t1070.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.006",
            "disp": "t1070.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1070.008",
            "disp": "t1070.008",
            "parent": "mitreattack"
        },
        {
            "value": "t1071",
            "disp": "t1071",
            "parent": "mitreattack"
        },
        {
            "value": "t1071.001",
            "disp": "t1071.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1072",
            "disp": "t1072",
            "parent": "mitreattack"
        },
        {
            "value": "t1078.001",
            "disp": "t1078.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1078.002",
            "disp": "t1078.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1078.003",
            "disp": "t1078.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1082",
            "disp": "t1082",
            "parent": "mitreattack"
        },
        {
            "value": "t1083",
            "disp": "t1083",
            "parent": "mitreattack"
        },
        {
            "value": "t1087",
            "disp": "t1087",
            "parent": "mitreattack"
        },
        {
            "value": "t1087.001",
            "disp": "t1087.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1087.002",
            "disp": "t1087.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1090.001",
            "disp": "t1090.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1090.002",
            "disp": "t1090.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1090.003",
            "disp": "t1090.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1091",
            "disp": "t1091",
            "parent": "mitreattack"
        },
        {
            "value": "t1095",
            "disp": "t1095",
            "parent": "mitreattack"
        },
        {
            "value": "t1098",
            "disp": "t1098",
            "parent": "mitreattack"
        },
        {
            "value": "t1102",
            "disp": "t1102",
            "parent": "mitreattack"
        },
        {
            "value": "t1104",
            "disp": "t1104",
            "parent": "mitreattack"
        },
        {
            "value": "t1106",
            "disp": "t1106",
            "parent": "mitreattack"
        },
        {
            "value": "t1110",
            "disp": "t1110",
            "parent": "mitreattack"
        },
        {
            "value": "t1110.001",
            "disp": "t1110.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1110.002",
            "disp": "t1110.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1110.003",
            "disp": "t1110.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1113",
            "disp": "t1113",
            "parent": "mitreattack"
        },
        {
            "value": "t1114",
            "disp": "t1114",
            "parent": "mitreattack"
        },
        {
            "value": "t1114.001",
            "disp": "t1114.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1115",
            "disp": "t1115",
            "parent": "mitreattack"
        },
        {
            "value": "t1119",
            "disp": "t1119",
            "parent": "mitreattack"
        },
        {
            "value": "t1120",
            "disp": "t1120",
            "parent": "mitreattack"
        },
        {
            "value": "t1123",
            "disp": "t1123",
            "parent": "mitreattack"
        },
        {
            "value": "t1124",
            "disp": "t1124",
            "parent": "mitreattack"
        },
        {
            "value": "t1125",
            "disp": "t1125",
            "parent": "mitreattack"
        },
        {
            "value": "t1127",
            "disp": "t1127",
            "parent": "mitreattack"
        },
        {
            "value": "t1127.001",
            "disp": "t1127.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1132.001",
            "disp": "t1132.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1134.001",
            "disp": "t1134.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1134.002",
            "disp": "t1134.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1134.003",
            "disp": "t1134.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1134.004",
            "disp": "t1134.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1134.005",
            "disp": "t1134.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1135",
            "disp": "t1135",
            "parent": "mitreattack"
        },
        {
            "value": "t1136.002",
            "disp": "t1136.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1176",
            "disp": "t1176",
            "parent": "mitreattack"
        },
        {
            "value": "t1185",
            "disp": "t1185",
            "parent": "mitreattack"
        },
        {
            "value": "t1187",
            "disp": "t1187",
            "parent": "mitreattack"
        },
        {
            "value": "t1190",
            "disp": "t1190",
            "parent": "mitreattack"
        },
        {
            "value": "t1197",
            "disp": "t1197",
            "parent": "mitreattack"
        },
        {
            "value": "t1200",
            "disp": "t1200",
            "parent": "mitreattack"
        },
        {
            "value": "t1201",
            "disp": "t1201",
            "parent": "mitreattack"
        },
        {
            "value": "t1204",
            "disp": "t1204",
            "parent": "mitreattack"
        },
        {
            "value": "t1207",
            "disp": "t1207",
            "parent": "mitreattack"
        },
        {
            "value": "t1210",
            "disp": "t1210",
            "parent": "mitreattack"
        },
        {
            "value": "t1211",
            "disp": "t1211",
            "parent": "mitreattack"
        },
        {
            "value": "t1212",
            "disp": "t1212",
            "parent": "mitreattack"
        },
        {
            "value": "t1216",
            "disp": "t1216",
            "parent": "mitreattack"
        },
        {
            "value": "t1216.001",
            "disp": "t1216.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1217",
            "disp": "t1217",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.001",
            "disp": "t1218.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.002",
            "disp": "t1218.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.004",
            "disp": "t1218.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.005",
            "disp": "t1218.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.007",
            "disp": "t1218.007",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.008",
            "disp": "t1218.008",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.009",
            "disp": "t1218.009",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.010",
            "disp": "t1218.010",
            "parent": "mitreattack"
        },
        {
            "value": "t1218.013",
            "disp": "t1218.013",
            "parent": "mitreattack"
        },
        {
            "value": "t1219",
            "disp": "t1219",
            "parent": "mitreattack"
        },
        {
            "value": "t1220",
            "disp": "t1220",
            "parent": "mitreattack"
        },
        {
            "value": "t1222",
            "disp": "t1222",
            "parent": "mitreattack"
        },
        {
            "value": "t1222.001",
            "disp": "t1222.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1482",
            "disp": "t1482",
            "parent": "mitreattack"
        },
        {
            "value": "t1484.001",
            "disp": "t1484.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1485",
            "disp": "t1485",
            "parent": "mitreattack"
        },
        {
            "value": "t1486",
            "disp": "t1486",
            "parent": "mitreattack"
        },
        {
            "value": "t1489",
            "disp": "t1489",
            "parent": "mitreattack"
        },
        {
            "value": "t1491.001",
            "disp": "t1491.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1496",
            "disp": "t1496",
            "parent": "mitreattack"
        },
        {
            "value": "t1497.001",
            "disp": "t1497.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1499.001",
            "disp": "t1499.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1499.004",
            "disp": "t1499.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1505.002",
            "disp": "t1505.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1505.003",
            "disp": "t1505.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1505.005",
            "disp": "t1505.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1518",
            "disp": "t1518",
            "parent": "mitreattack"
        },
        {
            "value": "t1518.001",
            "disp": "t1518.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1526",
            "disp": "t1526",
            "parent": "mitreattack"
        },
        {
            "value": "t1528",
            "disp": "t1528",
            "parent": "mitreattack"
        },
        {
            "value": "t1529",
            "disp": "t1529",
            "parent": "mitreattack"
        },
        {
            "value": "t1531",
            "disp": "t1531",
            "parent": "mitreattack"
        },
        {
            "value": "t1539",
            "disp": "t1539",
            "parent": "mitreattack"
        },
        {
            "value": "t1542.001",
            "disp": "t1542.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1542.003",
            "disp": "t1542.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1543",
            "disp": "t1543",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.001",
            "disp": "t1546.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.002",
            "disp": "t1546.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.003",
            "disp": "t1546.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.007",
            "disp": "t1546.007",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.008",
            "disp": "t1546.008",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.010",
            "disp": "t1546.010",
            "parent": "mitreattack"
        },
        {
            "value": "t1546.013",
            "disp": "t1546.013",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.002",
            "disp": "t1547.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.005",
            "disp": "t1547.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.008",
            "disp": "t1547.008",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.009",
            "disp": "t1547.009",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.014",
            "disp": "t1547.014",
            "parent": "mitreattack"
        },
        {
            "value": "t1550.002",
            "disp": "t1550.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1550.003",
            "disp": "t1550.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1552.001",
            "disp": "t1552.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1552.002",
            "disp": "t1552.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1552.004",
            "disp": "t1552.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1552.006",
            "disp": "t1552.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1553",
            "disp": "t1553",
            "parent": "mitreattack"
        },
        {
            "value": "t1553.002",
            "disp": "t1553.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1553.004",
            "disp": "t1553.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1553.005",
            "disp": "t1553.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1554",
            "disp": "t1554",
            "parent": "mitreattack"
        },
        {
            "value": "t1555",
            "disp": "t1555",
            "parent": "mitreattack"
        },
        {
            "value": "t1555.003",
            "disp": "t1555.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1555.004",
            "disp": "t1555.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1556",
            "disp": "t1556",
            "parent": "mitreattack"
        },
        {
            "value": "t1556.002",
            "disp": "t1556.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1557",
            "disp": "t1557",
            "parent": "mitreattack"
        },
        {
            "value": "t1557.001",
            "disp": "t1557.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1558",
            "disp": "t1558",
            "parent": "mitreattack"
        },
        {
            "value": "t1558.003",
            "disp": "t1558.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1560",
            "disp": "t1560",
            "parent": "mitreattack"
        },
        {
            "value": "t1560.001",
            "disp": "t1560.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1562.006",
            "disp": "t1562.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1562.010",
            "disp": "t1562.010",
            "parent": "mitreattack"
        },
        {
            "value": "t1563.002",
            "disp": "t1563.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1564.003",
            "disp": "t1564.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1564.004",
            "disp": "t1564.004",
            "parent": "mitreattack"
        },
        {
            "value": "t1564.006",
            "disp": "t1564.006",
            "parent": "mitreattack"
        },
        {
            "value": "t1565",
            "disp": "t1565",
            "parent": "mitreattack"
        },
        {
            "value": "t1566.001",
            "disp": "t1566.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1567",
            "disp": "t1567",
            "parent": "mitreattack"
        },
        {
            "value": "t1567.002",
            "disp": "t1567.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1569",
            "disp": "t1569",
            "parent": "mitreattack"
        },
        {
            "value": "t1570",
            "disp": "t1570",
            "parent": "mitreattack"
        },
        {
            "value": "t1571",
            "disp": "t1571",
            "parent": "mitreattack"
        },
        {
            "value": "t1572",
            "disp": "t1572",
            "parent": "mitreattack"
        },
        {
            "value": "t1573",
            "disp": "t1573",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.001",
            "disp": "t1574.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.005",
            "disp": "t1574.005",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.007",
            "disp": "t1574.007",
            "parent": "mitreattack"
        },
        {
            "value": "t1574.011",
            "disp": "t1574.011",
            "parent": "mitreattack"
        },
        {
            "value": "t1584",
            "disp": "t1584",
            "parent": "mitreattack"
        },
        {
            "value": "t1587",
            "disp": "t1587",
            "parent": "mitreattack"
        },
        {
            "value": "t1587.001",
            "disp": "t1587.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1588",
            "disp": "t1588",
            "parent": "mitreattack"
        },
        {
            "value": "t1590.001",
            "disp": "t1590.001",
            "parent": "mitreattack"
        },
        {
            "value": "t1590.002",
            "disp": "t1590.002",
            "parent": "mitreattack"
        },
        {
            "value": "t1593.003",
            "disp": "t1593.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1608",
            "disp": "t1608",
            "parent": "mitreattack"
        },
        {
            "value": "t1615",
            "disp": "t1615",
            "parent": "mitreattack"
        },
        {
            "value": "t1620",
            "disp": "t1620",
            "parent": "mitreattack"
        },
        {
            "value": "t1649",
            "disp": "t1649",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-01-002",
            "disp": "car.2013-01-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-02-003",
            "disp": "car.2013-02-003",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-03-001",
            "disp": "car.2013-03-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-04-002",
            "disp": "car.2013-04-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-05-002",
            "disp": "car.2013-05-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-05-004",
            "disp": "car.2013-05-004",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-05-009",
            "disp": "car.2013-05-009",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-07-001",
            "disp": "car.2013-07-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-07-002",
            "disp": "car.2013-07-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-08-001",
            "disp": "car.2013-08-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-09-005",
            "disp": "car.2013-09-005",
            "parent": "mitreattack"
        },
        {
            "value": "car.2013-10-002",
            "disp": "car.2013-10-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2014-04-003",
            "disp": "car.2014-04-003",
            "parent": "mitreattack"
        },
        {
            "value": "car.2014-11-003",
            "disp": "car.2014-11-003",
            "parent": "mitreattack"
        },
        {
            "value": "car.2014-11-008",
            "disp": "car.2014-11-008",
            "parent": "mitreattack"
        },
        {
            "value": "car.2015-04-001",
            "disp": "car.2015-04-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2016-03-001",
            "disp": "car.2016-03-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2016-03-002",
            "disp": "car.2016-03-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2016-04-002",
            "disp": "car.2016-04-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2016-04-004",
            "disp": "car.2016-04-004",
            "parent": "mitreattack"
        },
        {
            "value": "car.2016-04-005",
            "disp": "car.2016-04-005",
            "parent": "mitreattack"
        },
        {
            "value": "car.2019-04-001",
            "disp": "car.2019-04-001",
            "parent": "mitreattack"
        },
        {
            "value": "car.2019-04-002",
            "disp": "car.2019-04-002",
            "parent": "mitreattack"
        },
        {
            "value": "car.2019-04-003",
            "disp": "car.2019-04-003",
            "parent": "mitreattack"
        },
        {
            "value": "car.2019-04-004",
            "disp": "car.2019-04-004",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2015.1641",
            "disp": "cve.2015.1641",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2017.0261",
            "disp": "cve.2017.0261",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2017.11882",
            "disp": "cve.2017.11882",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2017.8759",
            "disp": "cve.2017.8759",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2019.1388",
            "disp": "cve.2019.1388",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2020.10189",
            "disp": "cve.2020.10189",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2020.1048",
            "disp": "cve.2020.1048",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2020.1350",
            "disp": "cve.2020.1350",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2020.1472",
            "disp": "cve.2020.1472",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2020.1599",
            "disp": "cve.2020.1599",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.1675",
            "disp": "cve.2021.1675",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.26084",
            "disp": "cve.2021.26084",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.26857",
            "disp": "cve.2021.26857",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.31979",
            "disp": "cve.2021.31979",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.33771",
            "disp": "cve.2021.33771",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.34527",
            "disp": "cve.2021.34527",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.35211",
            "disp": "cve.2021.35211",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.40444",
            "disp": "cve.2021.40444",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.41379",
            "disp": "cve.2021.41379",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.42278",
            "disp": "cve.2021.42278",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2021.42287",
            "disp": "cve.2021.42287",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2022.29072",
            "disp": "cve.2022.29072",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2022.41120",
            "disp": "cve.2022.41120",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2023.21746",
            "disp": "cve.2023.21746",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2023.23397",
            "disp": "cve.2023.23397",
            "parent": "mitreattack"
        },
        {
            "value": "cve.2023.36884",
            "disp": "cve.2023.36884",
            "parent": "mitreattack"
        },
        {
            "value": "detection.emerging_threats",
            "disp": "detection.emerging_threats",
            "parent": "mitreattack"
        },
        {
            "value": "detection.threat_hunting",
            "disp": "detection.threat_hunting",
            "parent": "mitreattack"
        },
        {
            "value": "t1548.003",
            "disp": "t1548.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1053.003",
            "disp": "t1053.003",
            "parent": "mitreattack"
        },
        {
            "value": "t1136",
            "disp": "t1136",
            "parent": "mitreattack"
        },
        {
            "value": "t1499",
            "disp": "t1499",
            "parent": "mitreattack"
        },
        {
            "value": "t1547.006",
            "disp": "t1547.006",
            "parent": "mitreattack"
        },
        {
            "value": "RDP",
            "disp": "RDP",
            "parent": "mitreattack"
        }]},
        {"threatgroup": [
            {
                "value": "apt24",
                "disp": "APT24",
                "parent": "threatgroup"
            },
            {
                "value": "apt25",
                "disp": "APT25",
                "parent": "threatgroup"
            }
        ]}
    ],
    "multi_select":true,
    "mandatory":false
    },
},
"informations":{
    "status":{"values":[
        {"disp":"New","value":"new","count": 10298},
        {"disp":"Open","value":"open","count": 108},
        {"disp":"Investigation","value":"investigation","count": 456},
        {"disp":"Incident","value":"incident","count": 987},
        {"disp":"Close","value":"close","count": null}
      ],"multi_select":true,
      "mandatory":false},
}
  }

//   "tags":{
//     "values":
//     [
//     {
//         "value": "pcidss",
//         "disp": "PCI-DSS",
//         "parent": "compliance"
//     },
//     {
//         "value": "gprc",
//         "disp": "GPRC",
//         "parent": "compliance"
//     },
//     {
//         "value": "iso27001",
//         "disp": "ISO 27001",
//         "parent": "compliance"
//     },
//     {
//         "value": "hippa",
//         "disp": "HIPPA",
//         "parent": "compliance"
//     },
//     {
//         "value": "low_diskspace",
//         "disp": "low_diskspace",
//         "parent": "compliance"
//     },
//     {
//         "value": "connection_attempt",
//         "disp": "connection_attempt",
//         "parent": "compliance"
//     },
//     {
//         "value": "gdpr",
//         "disp": "GDPR",
//         "parent": "compliance"
//     },
//     {
//         "value": "exploit_attempt",
//         "disp": "exploit_attempt",
//         "parent": "compliance"
//     },
//     {
//         "value": "invalid_login",
//         "disp": "invalid_login",
//         "parent": "compliance"
//     },
//     {
//         "value": "config_changed",
//         "disp": "config_changed",
//         "parent": "compliance"
//     },
//     {
//         "value": "authentication_failures",
//         "disp": "authentication_failures",
//         "parent": "compliance"
//     },
//     {
//         "value": "promisc",
//         "disp": "promisc",
//         "parent": "compliance"
//     },
//     {
//         "value": "gpg",
//         "disp": "GPG",
//         "parent": "compliance"
//     },
//     {
//         "value": "tsc",
//         "disp": "TSC",
//         "parent": "compliance"
//     },
//     {
//         "value": "recon",
//         "disp": "recon",
//         "parent": "compliance"
//     },
//     {
//         "value": "nist",
//         "disp": "NIST",
//         "parent": "compliance"
//     },
//     {
//         "value": "system_shutdown",
//         "disp": "system_shutdown",
//         "parent": "compliance"
//     },
//     {
//         "value": "authentication_failed",
//         "disp": "authentication_failed",
//         "parent": "compliance"
//     },
//     {
//         "value": "authentication_success",
//         "disp": "authentication_success",
//         "parent": "compliance"
//     },
//     {
//         "value": "service_availability",
//         "disp": "service_availability",
//         "parent": "compliance"
//     },
//     {
//         "value": "access_denied",
//         "disp": "access_denied",
//         "parent": "compliance"
//     },
//       {
//           "value": "reconnaissance",
//           "disp": "Reconnaissance",
//           "parent": "killchain"
//       },
//       {
//           "value": "threatgroup1319",
//           "disp": "Threat Group 1319",
//           "parent": "killchain"
//       },
      
//         {
//             "value": "command_and_control",
//             "disp": "command_and_control",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "credential_access",
//             "disp": "credential_access",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "defense_evasion",
//             "disp": "defense_evasion",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "execution",
//             "disp": "execution",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "impact",
//             "disp": "impact",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "lateral_movement",
//             "disp": "lateral_movement",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "persistence",
//             "disp": "persistence",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "privilege_escalation",
//             "disp": "privilege_escalation",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "resource_development",
//             "disp": "resource_development",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003",
//             "disp": "t1003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.001",
//             "disp": "t1003.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1008",
//             "disp": "t1008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.002",
//             "disp": "t1021.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036.003",
//             "disp": "t1036.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1047",
//             "disp": "t1047",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1053",
//             "disp": "t1053",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1053.005",
//             "disp": "t1053.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059.005",
//             "disp": "t1059.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059.007",
//             "disp": "t1059.007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.005",
//             "disp": "t1070.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1105",
//             "disp": "t1105",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1112",
//             "disp": "t1112",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1133",
//             "disp": "t1133",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1137",
//             "disp": "t1137",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1137.006",
//             "disp": "t1137.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1140",
//             "disp": "t1140",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1202",
//             "disp": "t1202",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1203",
//             "disp": "t1203",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1204.002",
//             "disp": "t1204.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218",
//             "disp": "t1218",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.011",
//             "disp": "t1218.011",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1221",
//             "disp": "t1221",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1490",
//             "disp": "t1490",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1543.003",
//             "disp": "t1543.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546",
//             "disp": "t1546",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.009",
//             "disp": "t1546.009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.011",
//             "disp": "t1546.011",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.012",
//             "disp": "t1546.012",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.015",
//             "disp": "t1546.015",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.001",
//             "disp": "t1547.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.003",
//             "disp": "t1547.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.004",
//             "disp": "t1547.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.010",
//             "disp": "t1547.010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1548",
//             "disp": "t1548",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1548.002",
//             "disp": "t1548.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1553.003",
//             "disp": "t1553.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1559.002",
//             "disp": "t1559.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562",
//             "disp": "t1562",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562.001",
//             "disp": "t1562.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562.002",
//             "disp": "t1562.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562.004",
//             "disp": "t1562.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564",
//             "disp": "t1564",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564.001",
//             "disp": "t1564.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564.002",
//             "disp": "t1564.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1566",
//             "disp": "t1566",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1569.002",
//             "disp": "t1569.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574",
//             "disp": "t1574",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.002",
//             "disp": "t1574.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.012",
//             "disp": "t1574.012",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1588.002",
//             "disp": "t1588.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "2013-01-002",
//             "disp": "2013-01-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "2019-04-001",
//             "disp": "2019-04-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "discovery",
//             "disp": "discovery",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059-001",
//             "disp": "t1059-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027",
//             "disp": "t1027",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059.001",
//             "disp": "t1059.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1049",
//             "disp": "t1049",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "initial_access",
//             "disp": "initial_access",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1078",
//             "disp": "t1078",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1069.001",
//             "disp": "t1069.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "collection",
//             "disp": "collection",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1074.001",
//             "disp": "t1074.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1136.001",
//             "disp": "t1136.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0049",
//             "disp": "g0049",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0111",
//             "disp": "s0111",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1071.004",
//             "disp": "t1071.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.003",
//             "disp": "t1218.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0005",
//             "disp": "s0005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1137.002",
//             "disp": "t1137.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1090",
//             "disp": "t1090",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547",
//             "disp": "t1547",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "2014-11-003 ",
//             "disp": "2014-11-003 ",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "2014-11-008",
//             "disp": "2014-11-008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "exfiltration",
//             "disp": "exfiltration",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0001",
//             "disp": "g0001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0004",
//             "disp": "g0004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0007",
//             "disp": "g0007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0009",
//             "disp": "g0009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0010",
//             "disp": "g0010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0016",
//             "disp": "g0016",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0020",
//             "disp": "g0020",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0022",
//             "disp": "g0022",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0027",
//             "disp": "g0027",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0030",
//             "disp": "g0030",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0032",
//             "disp": "g0032",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0035",
//             "disp": "g0035",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0044",
//             "disp": "g0044",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0045",
//             "disp": "g0045",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0046",
//             "disp": "g0046",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0047",
//             "disp": "g0047",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0050",
//             "disp": "g0050",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0060",
//             "disp": "g0060",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0064",
//             "disp": "g0064",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0069",
//             "disp": "g0069",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0075",
//             "disp": "g0075",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0091",
//             "disp": "g0091",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0092",
//             "disp": "g0092",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0093",
//             "disp": "g0093",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0096",
//             "disp": "g0096",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0115",
//             "disp": "g0115",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "g0128",
//             "disp": "g0128",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "reconnaissance",
//             "disp": "reconnaissance",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0002",
//             "disp": "s0002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0013",
//             "disp": "s0013",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0029",
//             "disp": "s0029",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0039",
//             "disp": "s0039",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0040",
//             "disp": "s0040",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0075",
//             "disp": "s0075",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0081",
//             "disp": "s0081",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0106",
//             "disp": "s0106",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0108",
//             "disp": "s0108",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0160",
//             "disp": "s0160",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0190",
//             "disp": "s0190",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0195",
//             "disp": "s0195",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0246",
//             "disp": "s0246",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0363",
//             "disp": "s0363",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0404",
//             "disp": "s0404",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0412",
//             "disp": "s0412",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "s0575",
//             "disp": "s0575",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1001.003",
//             "disp": "t1001.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.002",
//             "disp": "t1003.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.003",
//             "disp": "t1003.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.004",
//             "disp": "t1003.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.005",
//             "disp": "t1003.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1003.006",
//             "disp": "t1003.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1005",
//             "disp": "t1005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1007",
//             "disp": "t1007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1010",
//             "disp": "t1010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1012",
//             "disp": "t1012",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1016",
//             "disp": "t1016",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1018",
//             "disp": "t1018",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1020",
//             "disp": "t1020",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021",
//             "disp": "t1021",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.001",
//             "disp": "t1021.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.003",
//             "disp": "t1021.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.004",
//             "disp": "t1021.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.005",
//             "disp": "t1021.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1021.006",
//             "disp": "t1021.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027.001",
//             "disp": "t1027.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027.003",
//             "disp": "t1027.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027.004",
//             "disp": "t1027.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027.005",
//             "disp": "t1027.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1027.009",
//             "disp": "t1027.009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1033",
//             "disp": "t1033",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1035",
//             "disp": "t1035",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036",
//             "disp": "t1036",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036.002",
//             "disp": "t1036.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036.004",
//             "disp": "t1036.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036.005",
//             "disp": "t1036.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1036.007",
//             "disp": "t1036.007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1037.001",
//             "disp": "t1037.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1039",
//             "disp": "t1039",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1040",
//             "disp": "t1040",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1041",
//             "disp": "t1041",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1046",
//             "disp": "t1046",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1048",
//             "disp": "t1048",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1048.001",
//             "disp": "t1048.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1048.003",
//             "disp": "t1048.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1050",
//             "disp": "t1050",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1053.002",
//             "disp": "t1053.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1055",
//             "disp": "t1055",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1055.001",
//             "disp": "t1055.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1056.001",
//             "disp": "t1056.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1057",
//             "disp": "t1057",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059",
//             "disp": "t1059",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059.003",
//             "disp": "t1059.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1059.006",
//             "disp": "t1059.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1068",
//             "disp": "t1068",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1069",
//             "disp": "t1069",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1069.002",
//             "disp": "t1069.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070",
//             "disp": "t1070",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.001",
//             "disp": "t1070.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.003",
//             "disp": "t1070.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.004",
//             "disp": "t1070.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.006",
//             "disp": "t1070.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1070.008",
//             "disp": "t1070.008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1071",
//             "disp": "t1071",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1071.001",
//             "disp": "t1071.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1072",
//             "disp": "t1072",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1078.001",
//             "disp": "t1078.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1078.002",
//             "disp": "t1078.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1078.003",
//             "disp": "t1078.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1082",
//             "disp": "t1082",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1083",
//             "disp": "t1083",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1087",
//             "disp": "t1087",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1087.001",
//             "disp": "t1087.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1087.002",
//             "disp": "t1087.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1090.001",
//             "disp": "t1090.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1090.002",
//             "disp": "t1090.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1090.003",
//             "disp": "t1090.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1091",
//             "disp": "t1091",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1095",
//             "disp": "t1095",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1098",
//             "disp": "t1098",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1102",
//             "disp": "t1102",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1104",
//             "disp": "t1104",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1106",
//             "disp": "t1106",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1110",
//             "disp": "t1110",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1110.001",
//             "disp": "t1110.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1110.002",
//             "disp": "t1110.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1110.003",
//             "disp": "t1110.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1113",
//             "disp": "t1113",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1114",
//             "disp": "t1114",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1114.001",
//             "disp": "t1114.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1115",
//             "disp": "t1115",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1119",
//             "disp": "t1119",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1120",
//             "disp": "t1120",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1123",
//             "disp": "t1123",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1124",
//             "disp": "t1124",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1125",
//             "disp": "t1125",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1127",
//             "disp": "t1127",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1127.001",
//             "disp": "t1127.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1132.001",
//             "disp": "t1132.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1134.001",
//             "disp": "t1134.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1134.002",
//             "disp": "t1134.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1134.003",
//             "disp": "t1134.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1134.004",
//             "disp": "t1134.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1134.005",
//             "disp": "t1134.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1135",
//             "disp": "t1135",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1136.002",
//             "disp": "t1136.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1176",
//             "disp": "t1176",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1185",
//             "disp": "t1185",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1187",
//             "disp": "t1187",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1190",
//             "disp": "t1190",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1197",
//             "disp": "t1197",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1200",
//             "disp": "t1200",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1201",
//             "disp": "t1201",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1204",
//             "disp": "t1204",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1207",
//             "disp": "t1207",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1210",
//             "disp": "t1210",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1211",
//             "disp": "t1211",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1212",
//             "disp": "t1212",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1216",
//             "disp": "t1216",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1216.001",
//             "disp": "t1216.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1217",
//             "disp": "t1217",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.001",
//             "disp": "t1218.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.002",
//             "disp": "t1218.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.004",
//             "disp": "t1218.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.005",
//             "disp": "t1218.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.007",
//             "disp": "t1218.007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.008",
//             "disp": "t1218.008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.009",
//             "disp": "t1218.009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.010",
//             "disp": "t1218.010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1218.013",
//             "disp": "t1218.013",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1219",
//             "disp": "t1219",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1220",
//             "disp": "t1220",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1222",
//             "disp": "t1222",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1222.001",
//             "disp": "t1222.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1482",
//             "disp": "t1482",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1484.001",
//             "disp": "t1484.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1485",
//             "disp": "t1485",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1486",
//             "disp": "t1486",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1489",
//             "disp": "t1489",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1491.001",
//             "disp": "t1491.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1496",
//             "disp": "t1496",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1497.001",
//             "disp": "t1497.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1499.001",
//             "disp": "t1499.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1499.004",
//             "disp": "t1499.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1505.002",
//             "disp": "t1505.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1505.003",
//             "disp": "t1505.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1505.005",
//             "disp": "t1505.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1518",
//             "disp": "t1518",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1518.001",
//             "disp": "t1518.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1526",
//             "disp": "t1526",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1528",
//             "disp": "t1528",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1529",
//             "disp": "t1529",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1531",
//             "disp": "t1531",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1539",
//             "disp": "t1539",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1542.001",
//             "disp": "t1542.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1542.003",
//             "disp": "t1542.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1543",
//             "disp": "t1543",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.001",
//             "disp": "t1546.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.002",
//             "disp": "t1546.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.003",
//             "disp": "t1546.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.007",
//             "disp": "t1546.007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.008",
//             "disp": "t1546.008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.010",
//             "disp": "t1546.010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1546.013",
//             "disp": "t1546.013",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.002",
//             "disp": "t1547.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.005",
//             "disp": "t1547.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.008",
//             "disp": "t1547.008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.009",
//             "disp": "t1547.009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.014",
//             "disp": "t1547.014",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1550.002",
//             "disp": "t1550.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1550.003",
//             "disp": "t1550.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1552.001",
//             "disp": "t1552.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1552.002",
//             "disp": "t1552.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1552.004",
//             "disp": "t1552.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1552.006",
//             "disp": "t1552.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1553",
//             "disp": "t1553",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1553.002",
//             "disp": "t1553.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1553.004",
//             "disp": "t1553.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1553.005",
//             "disp": "t1553.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1554",
//             "disp": "t1554",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1555",
//             "disp": "t1555",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1555.003",
//             "disp": "t1555.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1555.004",
//             "disp": "t1555.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1556",
//             "disp": "t1556",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1556.002",
//             "disp": "t1556.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1557",
//             "disp": "t1557",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1557.001",
//             "disp": "t1557.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1558",
//             "disp": "t1558",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1558.003",
//             "disp": "t1558.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1560",
//             "disp": "t1560",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1560.001",
//             "disp": "t1560.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562.006",
//             "disp": "t1562.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1562.010",
//             "disp": "t1562.010",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1563.002",
//             "disp": "t1563.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564.003",
//             "disp": "t1564.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564.004",
//             "disp": "t1564.004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1564.006",
//             "disp": "t1564.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1565",
//             "disp": "t1565",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1566.001",
//             "disp": "t1566.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1567",
//             "disp": "t1567",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1567.002",
//             "disp": "t1567.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1569",
//             "disp": "t1569",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1570",
//             "disp": "t1570",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1571",
//             "disp": "t1571",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1572",
//             "disp": "t1572",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1573",
//             "disp": "t1573",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.001",
//             "disp": "t1574.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.005",
//             "disp": "t1574.005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.007",
//             "disp": "t1574.007",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1574.011",
//             "disp": "t1574.011",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1584",
//             "disp": "t1584",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1587",
//             "disp": "t1587",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1587.001",
//             "disp": "t1587.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1588",
//             "disp": "t1588",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1590.001",
//             "disp": "t1590.001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1590.002",
//             "disp": "t1590.002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1593.003",
//             "disp": "t1593.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1608",
//             "disp": "t1608",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1615",
//             "disp": "t1615",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1620",
//             "disp": "t1620",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1649",
//             "disp": "t1649",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-01-002",
//             "disp": "car.2013-01-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-02-003",
//             "disp": "car.2013-02-003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-03-001",
//             "disp": "car.2013-03-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-04-002",
//             "disp": "car.2013-04-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-05-002",
//             "disp": "car.2013-05-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-05-004",
//             "disp": "car.2013-05-004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-05-009",
//             "disp": "car.2013-05-009",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-07-001",
//             "disp": "car.2013-07-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-07-002",
//             "disp": "car.2013-07-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-08-001",
//             "disp": "car.2013-08-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-09-005",
//             "disp": "car.2013-09-005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2013-10-002",
//             "disp": "car.2013-10-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2014-04-003",
//             "disp": "car.2014-04-003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2014-11-003",
//             "disp": "car.2014-11-003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2014-11-008",
//             "disp": "car.2014-11-008",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2015-04-001",
//             "disp": "car.2015-04-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2016-03-001",
//             "disp": "car.2016-03-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2016-03-002",
//             "disp": "car.2016-03-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2016-04-002",
//             "disp": "car.2016-04-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2016-04-004",
//             "disp": "car.2016-04-004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2016-04-005",
//             "disp": "car.2016-04-005",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2019-04-001",
//             "disp": "car.2019-04-001",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2019-04-002",
//             "disp": "car.2019-04-002",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2019-04-003",
//             "disp": "car.2019-04-003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "car.2019-04-004",
//             "disp": "car.2019-04-004",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2015.1641",
//             "disp": "cve.2015.1641",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2017.0261",
//             "disp": "cve.2017.0261",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2017.11882",
//             "disp": "cve.2017.11882",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2017.8759",
//             "disp": "cve.2017.8759",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2019.1388",
//             "disp": "cve.2019.1388",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2020.10189",
//             "disp": "cve.2020.10189",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2020.1048",
//             "disp": "cve.2020.1048",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2020.1350",
//             "disp": "cve.2020.1350",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2020.1472",
//             "disp": "cve.2020.1472",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2020.1599",
//             "disp": "cve.2020.1599",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.1675",
//             "disp": "cve.2021.1675",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.26084",
//             "disp": "cve.2021.26084",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.26857",
//             "disp": "cve.2021.26857",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.31979",
//             "disp": "cve.2021.31979",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.33771",
//             "disp": "cve.2021.33771",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.34527",
//             "disp": "cve.2021.34527",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.35211",
//             "disp": "cve.2021.35211",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.40444",
//             "disp": "cve.2021.40444",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.41379",
//             "disp": "cve.2021.41379",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.42278",
//             "disp": "cve.2021.42278",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2021.42287",
//             "disp": "cve.2021.42287",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2022.29072",
//             "disp": "cve.2022.29072",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2022.41120",
//             "disp": "cve.2022.41120",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2023.21746",
//             "disp": "cve.2023.21746",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2023.23397",
//             "disp": "cve.2023.23397",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "cve.2023.36884",
//             "disp": "cve.2023.36884",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "detection.emerging_threats",
//             "disp": "detection.emerging_threats",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "detection.threat_hunting",
//             "disp": "detection.threat_hunting",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1548.003",
//             "disp": "t1548.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1053.003",
//             "disp": "t1053.003",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1136",
//             "disp": "t1136",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1499",
//             "disp": "t1499",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "t1547.006",
//             "disp": "t1547.006",
//             "parent": "mitreattack"
//         },
//         {
//             "value": "RDP",
//             "disp": "RDP",
//             "parent": "mitreattack"
//         },
        
//           {
//               "value": "apt24",
//               "disp": "APT24",
//               "parent": "threatgroup"
//           },
//           {
//               "value": "apt25",
//               "disp": "APT25",
//               "parent": "threatgroup"
//           }
      
    
//         ],
//         "multi_select":true,
//         "mandatory":false
//     }




// getAlertFilter(){
//   return this.alertFilter
// }
getAnalytsList() {
    return this.http.post(environment.apiUrl + '/alerts/analystslist/get', { "user_name": this.sharedService.userName }, { headers: this.headers })
}



  alertsummarycomponentDestroyed: Subject<number> = new Subject();
  factsheetcomponentDestroyed: Subject<number> = new Subject();
  customerChangeLogggedOff: Subject<boolean> = new Subject();
  headers = new HttpHeaders({ 'content-type': 'application/json', 'charset': 'utf-8' });




  getAlertFilter(payload:any) {
    return this.http.post(environment.apiUrl + '/alerts/filters/get', JSON.stringify(payload), { headers: this.headers });
  }

  postnewrule = new RESTPROMISE(
    this.postRuleData,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/rule/new/post',
    'Alerts',
    this.toastService
)

posteditrule = new RESTPROMISE(
    this.postEditRuleData,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/rule/edit/post',
    'Alerts',
    this.toastService
)

postRuleData(ruleData: any) {
    return this.http.post(environment.apiUrl + '/alerts/rule/new/post', ruleData, { headers: this.headers });
}
postEditRuleData(ruleData: any) {
// console.log("api post",ruleData)
    return this.http.post(environment.apiUrl + '/alerts/rule/edit/post', ruleData, { headers: this.headers });
}

  checklogged() {
    return this.sharedService.$userLogged.getValue()
  }

  toStringify(postData: any) {
    return JSON.stringify(postData)
  }

  
  $destroy: Subject<boolean> = new Subject();
  providealertdata = new LongPollingPromiseAPIManagement(
    this.provideAlertData,
    this.http,
    this.alertsummarycomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    this.toastService,
    '/alerts/summary_onfilter/get',
    'Alerts'
  )
  provideAlertData(filters: any) {
    return this.http.post(environment.apiUrl + '/alerts/summary_onfilter/get', filters, { headers: this.headers })
  }

  provideeventlist =
    new LongPollingStateLessAPIManagement(
      this.provideEventList,
      this.http,
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/alerts/events/pagination/get',
      'Alerts',
      this.toastService,
    )

  provideEventList(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/events/pagination/get', alertdetail, { headers: this.headers });
  }

  provideruleDetails(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/ruledetails/get', alertdetail, { headers: this.headers })
  }

  provideAlertEvents =
    new AlertLongPollingAPIManagement(
      this.provide_alert_events,
      this.http,
      this.factsheetcomponentDestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/alerts/factsheetevents/get',
      'Alerts',
      this.toastService
    )
  provide_alert_events(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/factsheetevents/get', alertdetail, { headers: this.headers });
  }

  provideadditionalevents = (() => {
    return new LongPollingAPIManagement(
      this.provideadditionalEvents,
      this.http,
      this.factsheetcomponentDestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      'alerts/addevents/get',
      'Alerts',
      this.toastService
    )
  })
  provideadditionalEvents(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/addevents/get', reqobj, { headers: this.headers });
  }

  provideoverviewdata = new LongPollingAPIManagement(
    this.provideOverviewData,
    this.http,
    this.factsheetcomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    '/alerts/overview/get',
    'Alerts',
      this.toastService
  )
  provideOverviewData(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/overview/get', reqobj, { headers: this.headers });
  }

  provideDetaildata = new LongPollingAPIManagement(
    this.provideDetailData,
    this.http,
    this.factsheetcomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    '/alerts/detail/get',
    'Alerts',
      this.toastService
  )

  provideDetailData(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/detail/get', reqobj, { headers: this.headers });
  }

  provideeventsdata = new LongPollingAPIManagement(
    this.provideEventsData,
    this.http,
    this.factsheetcomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    '/alerts/events/get',
    'Alerts',
      this.toastService
  )
  provideEventsData(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/events/get', reqobj, { headers: this.headers });
  }

  provided3chartevents =
    new LongPollingAPIManagement(
      this.provideD3ChartEvents,
      this.http,
      this.factsheetcomponentDestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/alerts/addnodes_new/get',
      'Alerts',
      this.toastService
    )
  provideD3ChartEvents(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/addnodes_new/get', alertdetail, { headers: this.headers });
  }

  updated3chartevents =
    new LongPollingAPIManagement(
      this.updateD3ChartEvents,
      this.http,
      this.factsheetcomponentDestroyed.asObservable(),
      this.customerChangeLogggedOff.asObservable(),
      this.errorservice,
      '/alerts/updatenodes_new/get',
      'Alerts',
      this.toastService
    )

  updateD3ChartEvents(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/updatenodes_new/get', alertdetail, { headers: this.headers });
  }


  fieldsCardinalityGet = new RESTPROMISE(
    this.fieldscardinalityget,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/fieldsCardinality/get',
    'Alerts',
    this.toastService
)

fieldscardinalityget(ruleData: any) {
    return this.http.post(environment.apiUrl + '/alerts/fieldsCardinality/get', ruleData, { headers: this.headers });
}

dedupGet = new RESTPROMISE(
    this.dedupget,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/dedup/get',
    'Alerts',
    this.toastService
)

dedupget(ruleData: any) {
    return this.http.post(environment.apiUrl + '/alerts/dedup/get', ruleData, { headers: this.headers });
}

actionPost = new RESTPROMISE(
    this.actionpost,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/action/post',
    'Alerts',
    this.toastService
)

actionpost(ruleData: any) {
    return this.http.post(environment.apiUrl + '/alerts/action/post', ruleData, { headers: this.headers });
}


alertsGet = new LongPollingPromiseAPIManagement(
    this.alertsget,
    this.http,
    this.alertLandingcomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    this.toastService,
    '/alerts/alerts/get',
    'Alerts'
  )
  alertsget(filters: any) {
    return this.http.post(environment.apiUrl + '/alerts/alerts/get', filters, { headers: this.headers })
  }

  updateAlertActionPost = new RESTPROMISE(
    this.updateActionPost,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/dedupAction/post',
    'Alerts',
    this.toastService
)

// updateAlertActionPost(req_obj:any) {
//     return new Promise((resolve, reject) => {
//       this.updateActionPost(req_obj).
//         subscribe((data: any) => {
//           resolve(data);
//         },
//           (error) => {
//             reject(error);
//           })
//     // resolve({"status":1})
//     })
//   }

  alertsummaryget = new LongPollingPromiseAPIManagement(
    this.alertsSummaryGet,
    this.http,
    this.alertLandingcomponentDestroyed.asObservable(),
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    this.toastService,
    '/alerts/summary/get',
    'Alerts'
  )
  alertsSummaryGet(filters: any) {
    return this.http.post(environment.apiUrl + '/alerts/summary/get', filters, { headers: this.headers })
  }

  exploreActionPost = new RESTPROMISE(
    this.exploreActionpost,
    this.http,
    this.customerChangeLogggedOff.asObservable(),
    this.errorservice,
    'alerts/exploreAction/post',
    'Alerts',
    this.toastService
)

exploreActionpost(ruleData: any) {
    return this.http.post(environment.apiUrl + '/alerts/exploreAction/post', ruleData, { headers: this.headers });
}

  updateActionPost(req_obj:any){
    return this.http.post(environment.apiUrl + '/alerts/dedupAction/post', req_obj, { headers: this.headers })
  }


  provideHistoryGet(alertdetail: any) {
    return this.http.post(environment.apiUrl + '/alerts/history/get', JSON.stringify(alertdetail), { headers: this.headers });
  }

  postAssignedUers(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/assignuser/post', JSON.stringify(reqobj), { headers: this.headers });
  }

  postAddNotes(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/addnotes/post', JSON.stringify(reqobj), { headers: this.headers });
  }

  postAction(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/setaction/post', JSON.stringify(reqobj), { headers: this.headers });
  }

  getInstantFilters(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/instantFilters/get', JSON.stringify(reqobj), { headers: this.headers });
  }

  removeNodePost(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/remove_node/post', JSON.stringify(reqobj), { headers: this.headers });
  }
  
  getAlertsFields(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/fields/get', JSON.stringify(reqobj), { headers: this.headers });
  }
  lockAlert(alert_id: string, force_view:boolean) {
        
    // this.http.post(environment.apiUrl + '/alerts/view/get', JSON.stringify({ alert_id: alert_id,  force_view: force_view}), { headers: this.headers });
    return new Promise(async (resolve, reject) => {
         const request = JSON.stringify({ alert_id: alert_id,  force_view: force_view})
        //  console.log('request==',request);
        resolve(true)
         
        //  await this.http.post<any>(environment.apiUrl + '/alerts/lock/post', request, { headers: this.headers, withCredentials: true })
        //    .pipe(takeUntil(this.$destroy))
        //    .toPromise()
        //    .then((val) => {
        //     // console.log('val==',val);
        //     if (val.status == 0) {
        //       reject(val)
        //     }else{
        //       resolve(true)
        //     }
        //    })
        //    .catch(err => {
        //       reject('Something went wrong in the server');
        //     })
          })
  } 
  unlockAlert(reqobj: any) {
    return this.http.post(environment.apiUrl + '/alerts/unlock/post', JSON.stringify(reqobj), { headers: this.headers });
  }
  factsheettopnavMeta() {
    return this.sharedService.metaData.alert.factsheetMeta;
  }
  
  heatmapMeta() {
    return this.sharedService.metaData.alert.heatmapMeta;
  }


  //   ticketing screen
  alertpagelength: number = 1;

  alertFilters = new FormGroup({
      external: new FormGroup({
          timerange: new FormControl(),
          platform: new FormControl()
      }),
      internal: new FormGroup({
          alertstatus: new FormControl(''),
          alertcategory: new FormControl(''),
          alertsubcategory: new FormControl(''),
          alertreason: new FormControl('')
      }),
      itemPerPage: new FormControl(0),
      page: new FormControl(1)
  })

  status = []
  reasons = {}
  reason = []
  timeranges = []
  platformList =[]
  filter_labels = []
  alert_table_headers = []
  filterDefaults = {}

  alert_rows = []
  sample_data = { "total_items": 158160, "ticketingTableRows": [{ "cnt": 9, "tag": "cins", "date": "2025-05-11", "dstip": "103.8.188.54", "srcip": "20.150.192.63", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 21456, "rule_ref": "EOATTIM", "sentbyte": 6342, "handled_by": "", "ticket_ref": 6502, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 9, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.224", "srcip": "20.150.192.63", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 14490, "rule_ref": "EOATTIM", "sentbyte": 5826, "handled_by": "", "ticket_ref": 6503, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.104", "srcip": "20.163.15.91", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 184, "rule_ref": "EOATTIM", "sentbyte": 348, "handled_by": "", "ticket_ref": 6504, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.22", "srcip": "20.163.15.91", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 2688, "rule_ref": "EOATTIM", "sentbyte": 969, "handled_by": "", "ticket_ref": 6505, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.186", "srcip": "20.163.15.91", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 2687, "rule_ref": "EOATTIM", "sentbyte": 991, "handled_by": "", "ticket_ref": 6506, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.240", "srcip": "20.169.105.52", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 236, "rule_ref": "EOATTIM", "sentbyte": 648, "handled_by": "", "ticket_ref": 6507, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.96", "srcip": "20.169.105.52", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 184, "rule_ref": "EOATTIM", "sentbyte": 348, "handled_by": "", "ticket_ref": 6508, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.8.188.110", "srcip": "20.65.193.159", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 4446, "rule_ref": "EOATTIM", "sentbyte": 1308, "handled_by": "", "ticket_ref": 6509, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.23.150.36", "srcip": "20.65.193.159", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 5187, "rule_ref": "EOATTIM", "sentbyte": 1256, "handled_by": "", "ticket_ref": 6510, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }, { "cnt": 2, "tag": "cins", "date": "2025-05-11", "dstip": "103.8.188.40", "srcip": "20.65.194.87", "source": "Ciarmy", "dstport": "443", "service": "HTTPS", "rcvdbyte": 4018, "rule_ref": "EOATTIM", "sentbyte": 1347, "handled_by": "", "ticket_ref": 6511, "ticket_status": "open", "ticket_close_date": "2025-05-11", "ticket_raise_date": "2025-05-11", "ticket_closure_reason": "" }] }

  provideTickets(alertFilters: any) {
      return this.http.post(environment.apiUrl + '/ticketing/list/get/new', alertFilters, { headers: this.headers })
      // return of(this.sample_data)
      // return of([])
  }
}